// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/mind-body-upset-stomach.svg';

export const MindBodyUpsetStomach = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
